import * as React from 'react';
import Select from 'react-select';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { getAllAddresses, selectLocations, Location } from '../../redux/AddressSlice';

const AddressEditor = (props: any) => {

    const dispatch = useAppDispatch();
    const locationSelector = useAppSelector(selectLocations);

    const cityLocationOptions = getFlattenedCityOptions();
    const servesInCountyOptions = getFlattenedCountyOptions();

    const [city, setCity] = React.useState<{ value: string; label: string; } | "" | undefined>();
 
    function getFlattenedCityOptions(): Array<{ value: string; label: string; }> {
        let result: Array<{ value: string; label: string; }> = new Array<{ value: string; label: string; }>();

        locationSelector.forEach((stateNode: any) => {
            if (!props.hasOwnProperty("stateRestriction") || stateNode.name === props.stateRestriction )
            {
                stateNode.children.forEach((countyNode: any) => {

                    if (countyNode.level == "CITY") {
                        result.push({ value: countyNode.code, label: stateNode.name == 'Florida' ? countyNode.name : countyNode.name + " (" + stateNode.name + ")" });
                    }

                    countyNode.children.forEach((cityNode: any) => {
                        if (cityNode.level == "CITY") {
                            result.push({ value: cityNode.code, label: cityNode.name });
                        }
                    })
                })
            }
        })
        // todo: sort the list by label
        result.sort((a, b) => a.label > b.label ? 1 : -1);

        return result;
    }

    function getFlattenedCountyOptions(): Array<{ value: string; label: string; }> {
        let result: Array<{ value: string; label: string; }> = new Array<{ value: string; label: string; }>();

        locationSelector.forEach((stateNode: any) => {
            if (!props.hasOwnProperty("stateRestriction") || stateNode.name === props.stateRestriction) {
                stateNode.children.forEach((countyNode: any) => {

                    if (countyNode.level == "COUNTY") {
                        result.push({value: countyNode.code, label: countyNode.name});
                    }
                })
            }
        })

        result.sort((a, b) => a.label > b.label ? 1 : -1);

        return result;
    }
    
    const shouldDisableZipEditing = function () {
        if (!props.canEdit) {
            return true;
        }
        if (props.hasOwnProperty("disableZipEditing")) {
            return true;
        }
        return false;
    }

    const handleServesInCountyChange = (selectedItems: Array<{ value: string; label: string }>) => {
        const selectedCountyCodes: Array<string>  = selectedItems && selectedItems.length > 0 ?
            selectedItems.map((item: { value: string; label: string }) => item.value) : [];

        var convertedEntityCodes: Array<number> = [];

        //check if selectedCountyCodes is different from props.servesInCountyCodes to avoid unnecessary re-renders
        if (selectedCountyCodes.length !== props.servesInCountyCodes.length) {
            convertedEntityCodes = selectedCountyCodes
                                            .map(n => Number(n)).filter(n => !isNaN(n));
            props.setServesInCountyCodes(convertedEntityCodes);
        }
        else if (selectedCountyCodes.length === props.servesInCountyCodes.length) {
            const allMatch = selectedCountyCodes.every((code: string) => props.servesInCountyCodes.includes(code));
            if (allMatch == false) {

                convertedEntityCodes = selectedCountyCodes
                                            .map(n => Number(n)).filter(n => !isNaN(n));
                props.setServesInCountyCodes(convertedEntityCodes);
            }
        }      
    }

    const handleCitySelectorChange = (selectItem: { value: string; label: string }) => {

        //attempt to retrieve the state county city hierarchy given the selected item value
        const stateCountyCityHierarchy = locationSelector.find((stateNode: Location) => stateNode.children
                                                            .some((countyNode: Location) => countyNode.children
                                                                .some((cityNode: Location) => cityNode.code == selectItem.value)));

        //if successful use hiearchy to set the state and county
        if (stateCountyCityHierarchy !== undefined) {
            props.setState(stateCountyCityHierarchy.name);

            const countyNode = stateCountyCityHierarchy.children.find((countyNode: Location) => countyNode.children
                                                                    .some((cityNode: Location) => cityNode.code == selectItem.value));

            if (countyNode !== undefined) {
                props.setCounty(countyNode.name);
            } else {
                props.setCounty("");
            }
        }
        //if unsuccessful retrieve state city hierarchy
        else {

           const stateCityHierarchy = locationSelector.find((stateNode: Location) => stateNode.children
                                                        .some((cityNode: Location) => cityNode.code == selectItem.value));

            props.setCounty("");

            //if successful set state
            if (stateCityHierarchy !== undefined) {
                props.setState(stateCityHierarchy.name)
            }
            //if unsuccessful make it blank
            else {
                props.setState("");             
            }

        }

        // Updating the state with the selected value
        setCity({ value: selectItem.value, label: selectItem.label });
        props.setCityCode(selectItem.value);
    }

    React.useEffect(() => {
        if (locationSelector === null ||
            (locationSelector !== null && locationSelector.length === 0)
        ) {
            dispatch(getAllAddresses());
        }
    }, []);

    React.useEffect(() => {
        if (props.cityCode) {
            var selectedOption = cityLocationOptions.find(element => element.value == props.cityCode);

            if (selectedOption) {
                handleCitySelectorChange({ value: selectedOption.value, label: selectedOption.label })
            }
            else {
                props.setCityCode(null);
                setCity("");
            }
        } else {
            props.setCityCode(null);
            setCity("");
        }
    }, [props])


    return (
        <React.Fragment>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >Street:</Label>
                    </Col>
                    <Col md="9">
                        <Input type="text" value={props.street || ""}
                            onChange={(e) => props.setStreet(e.currentTarget.value)}
                            disabled={!props.canEdit} />
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >P.O. Box:</Label>
                    </Col>
                    <Col md="9">
                        <Input type="text" value={props.poBox || ""}
                            onChange={(e) => props.setPoBox(e.currentTarget.value)}
                            disabled={!props.canEdit} />
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >City:</Label>
                    </Col>
                    <Col md="9">

                        <Select
                            value={city}
                            onChange={handleCitySelectorChange}
                            options={cityLocationOptions}
                            style={{ width: "25em" }}
                            isDisabled={!props.canEdit}
                        />

                    </Col>
                </Row>
            </FormGroup>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >County: </Label>
                    </Col>
                    <Col md="9">
                        <Input disabled type="text" value={props.county || ""} />
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >State: </Label>
                    </Col>
                    <Col md="9">
                        <Input disabled type="text" value={props.state || ""} />
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >Zip Code:</Label>
                    </Col>
                    <Col md="9">
                        <Input type="text" value={props.zipCode || ""}
                            onChange={(e) => props.setZipCode(e.currentTarget.value)}
                            disabled={shouldDisableZipEditing()} />
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup hidden={!props.servesInCountyCodes && !props.setServesInCountyCodes}>
                <Row>
                    <Col >
                        <Label >Serves In County(ies):</Label>
                    </Col>
                    <Col md="9">
                        <Select
                            value={servesInCountyOptions && props.servesInCountyCodes ? servesInCountyOptions.filter((element: { value: string; label: string; }) => props.servesInCountyCodes.some((code: number) => code.toString() == element.value)) : []}
                            closeMenuOnSelect={false}
                            isMulti
                            options={servesInCountyOptions}
                            onChange={handleServesInCountyChange}
                            />
                    </Col>
                </Row>
            </FormGroup>
        </React.Fragment>
    );
}

export default AddressEditor;